import { encodeCmcd } from './encodeCmcd.js';
/**
 * Convert a CMCD data object to a URL encoded string.
 *
 * @param cmcd - The CMCD object to convert.
 * @param options - Options for encoding the CMCD object.
 *
 * @returns The URL encoded CMCD data.
 *
 * @group CMCD
 *
 * @beta
 */
export function toCmcdUrl(cmcd, options = {}) {
    if (!cmcd) {
        return '';
    }
    const params = encodeCmcd(cmcd, options);
    return encodeURIComponent(params);
}
//# sourceMappingURL=toCmcdUrl.js.map